import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type * as Types from './types';

const domain = 'PARENTAL_PERMISSON_MATRIX';

export const {
    action: fetchPermissionDescriptions,
    success: fetchPermissionDescriptionsSuccess,
    failed: fetchPermissionDescriptionsFailed,
} = createAction(
    `${domain}_FETCH_DESCRIPTION`,
    (institutionId: string, kind: Types.Kind) => ({
        institutionId,
        kind,
    }),
    (institutionId: string, kind: Types.Kind, permissions: Types.PermissionDescription[]) => ({
        institutionId,
        kind,
        permissions,
    }),
);

export const {
    action: fetchPermissionResults,
    success: fetchPermissionResultsSuccess,
    failed: fetchPermissionResultsFailed,
} = createAction(
    `${domain}_FETCH_RESULTS`,
    (
        institutionId: string,
        kind: Types.Kind,
        permissions: Types.PermissionDescription[],
        filterValues: Types.FilterValues,
    ) => ({
        institutionId,
        kind,
        permissions,
        filterValues,
    }),
    (permissionResults: Types.PermissionResult[], total: number) => ({
        permissionResults,
        total,
    }),
);
